import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerTable from "../components/CustomerTable";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import { LOCATION_ID, TOKEN } from "..";
import { Link } from "react-router-dom";

const CustomerPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(100); // Default rows per page
  const [searchQuery, setSearchQuery] = useState(""); // Search input

  const fetchContacts = async (page = 1, rowsPerPage = limit) => {
      const TOKEN = localStorage.getItem('tokenID');
      const LocationId = localStorage.getItem('locationID');
    console.log(TOKEN)
    setLoading(true);
    const options = {
      method: "GET",
      url: "https://services.leadconnectorhq.com/contacts/",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        Version: "2021-07-28",
        Accept: "application/json",
      },
      params: {
        locationId: LocationId,
        limit: rowsPerPage,
        page: page,
      },
    };

    try {
      const response = await axios.request(options);
      const contacts = response.data.contacts || [];
      
      const currentUser = JSON.parse(localStorage.getItem('user'));
      

      let filteredContacts = [];
      if (currentUser?.roles?.role === 'admin') {
        filteredContacts = contacts.map((contact) => ({
          id: contact.id,
          name: `${contact.firstName || ""} ${contact.lastName || ""}`.trim() || "N/A",
          phone: contact.phone || "N/A",
          email: contact.email || "N/A",
        }));
      } else {
        filteredContacts = contacts
          .filter(item => item.assignedTo === currentUser?.id)
          .map((contact) => ({
            id: contact.id,
            name: `${contact.firstName || ""} ${contact.lastName || ""}`.trim() || "N/A",
            phone: contact.phone || "N/A",
            email: contact.email || "N/A",
          }));
      }

      
      setData(filteredContacts);
      setTotalPages(response.data.meta?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching contacts:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts(currentPage, limit);
  }, [currentPage, limit]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1); // Reset to first page when limit changes
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Customers" />
 <div className="d-flex justify-content-end mb-3">
        <Link to={'/add-customer'} className="btn btn-info">
          + Add New Contact
        </Link>
      </div>
      {loading ? (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      ) : null}

      {data.length === 0 && !loading ? (
        <p>No Customers Found....</p>
      ) : (
        <CustomerTable 
          data={data}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          limit={limit}
          onLimitChange={handleLimitChange}
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
        />
      )}
    </MasterLayout>
  );
};

export default CustomerPage;